import type { LeftAlignedImageWithTextFields } from './types'

export const leftAlignedImageWithTextMockData: LeftAlignedImageWithTextFields = {
  heading: "What's inside a Gousto food box?",
  body: 'We pack our food boxes with everything you need to whip up seriously tasty meals, while keeping things as environmentally friendly as possible.\n\nWith fresh ingredients, easy-to-follow recipe cards and clever packaging, dinner is ready when you are.',
  image: {
    uid: 'inside-gousto-box',
    url: 'https://eu-images.contentstack.com/v3/assets/blt249ad47e3410b9aa/bltf10b9205f4494730/69c539e5a3472f1f9f3236bb/george.jpeg',
    title: 'Open Gousto box showing fresh ingredients and recipe cards',
    filename: 'left-aligned-image.jpg',
    content_type: 'image/jpeg',
  },
  image_mobile: {
    uid: 'inside-gousto-box-mobile',
    url: 'https://eu-images.contentstack.com/v3/assets/blt249ad47e3410b9aa/bltf10b9205f4494730/69c539e5a3472f1f9f3236bb/george.jpeg',
    title: 'Open Gousto box showing fresh ingredients and recipe cards',
    filename: 'left-aligned-image-mobile.jpg',
    content_type: 'image/jpeg',
  },
  image_alt: 'Open Gousto box showing fresh ingredients and recipe cards',
  cta: {
    text: 'Try Gousto with 50% off',
    intent: 'link',
    variant: 'primary',
    href: '/signup',
  },
}
